export const roleStatusFilter = () => [
  { value: 'pending', label: 'Pending Approval' },
  { value: 'draft', label: 'Draft' },
  { value: 'active_open', label: 'Active, open' },
  { value: 'active_closed', label: 'Active, closed' },
  { value: 'archived', label: 'Archived' },
];
